export default {
    txt_welcome: 'Velkommen',
    txt_dataover: 'Overblik',
    txt_chance: 'Salgs leads',
    txt_device: 'Enhed',
    txt_Device: 'Enhed',
    txt_chinese: '中文-Chinese',
    txt_english: '英文-English',
    txt_malay: '马来语-Malay',
    txt_reports: 'Historie',
    txt_setting: 'Indstilling',
    txt_dymanager: 'Medarbejdere',
    txt_account: 'ID:Konto',
    txt_userstatus: 'Bruger identitet',
    txt_name: 'Navn',
    txt_contactway: 'Kontakt',
    txt_accountsafe: 'Konto sikkerhed',
    txt_basicinfo: 'Basis information',
    txt_updatepassword: 'Ændre password',
    txt_storeinfomation: 'Oplysninger om forretning',
    txt_storename: 'Navn på forretning',
    txt_storephone: 'Mobiltelefon',
    txt_storeaddress: 'Adresse',
    txt_AppInfomation: 'App information',
    txt_currentversion: 'Nuværende version',
    txt_software: 'Software opdater',
    txt_loginout: 'Afslut login.',
    txt_updatelanguage: 'Sprog',
    txt_updateto: 'Opdatering til',
    txt_zwgx: 'Ingen opdatering',
    txt_dz: 'Manager',
    txt_sh: 'Forretning',
    txt_dy: 'Medarbejder',
    txt_bdsj: 'Bind mobiltelefon',
    txt_shxx: 'Forretning information',
    txt_shname: 'Forretning navn',
    txt_ssmd: 'Butik',
    txt_qx: 'Afbryd',
    txt_mendian: 'Butik',
  
  
    //数据总览模块
    txt_sTime: 'Vælg periode',
    txt_car_check: 'Inspektions interval',
    txt_findchance: 'Salgs leads',
    txt_trackchace: 'Tracking rate',
    txt_transform: 'Konversions rate',
    txt_TotalData: 'Overblik',
    txt_xxsj: 'Detaljerede data',
    txt_zhsj: 'Konverteringsdata',
    txt_TireWear: 'Dæk slitage',
    txt_DataHopper: 'Tragt',
    txt_jdcc: 'Bil traffik',
    txt_CheckCar: 'Scannet',
    txt_ChanceNum: "Salgs leads antal",
    txt_TrackNum: 'Tracked',
    txt_TranseformNum: 'Konversion',
    txt_UnTrack: 'Untracked',
    txt_l: 'Køretøjer',
    txt_Time: 'Tid',
    txt_Pwear1: 'Enhed',
    txt_car_plate: 'Nummerplade',
    txt_Wear: 'Slid',
    txt_Pwear: 'Skæv Slitage',
    txt_NoData: 'Ingen data',
    txt_GoodState: 'Normal',
    txt_Border: 'Grænse',
    txt_replace: 'Udskift',
    txt_Total_Check: 'Total',
    txt_yel: 'Køretøjer',
    txt_pmqk: 'Ujævn slitage',
    txt_LightWear: 'Ujævn slitage (lettere)',
    txt_GraveWear: 'Ujævn slitage (seriøs)',
    txt_hwtj: "Rotations antal",
    txt_wxhw: 'Rotation ikke nødvendigt',
    txt_xyhw: 'Rotation nødvendigt',
    txt_jcxq: 'Detaljer',
    txt_zhxq: 'Detaljeret konversion',
    txt_cc: 'Køretøjer',
    txt_bfb: '%',
    txt_ltxs: 'Dæk salg',
    txt_sldw: 'Dæk udskiftning',
    txt_ddlph: 'Balance',
    txt_qt: 'Andet',
    txt_zhqs: 'Konversion trend',
    txt_ltxl: "Dæk salg antal",
    txt_ltfw: 'Dæk service',
    txt_jt: 'I dag',
    txt_zt: 'I går',
    txt_bz: 'Denne uge',
    txt_by: 'Denne måned',
    txt_sy: 'Sidste måned',
    txt_jn: 'Dette år',
    txt_zhcl: "Konversions antal (køretøjer)",
    txt_zhl: 'Konversions interval',
    txt_abjx: 'Køretøjsfordeling af "Boundary state"',
    txt_aljg: 'Køretøjs distribution af "Udskift øjeblikkeligt"',
    txt_qwpm: 'Køretøjs distribution af "Lettere ujævnt slid" ',
    txt_ayzp: 'Køretøjs distribution af "Seriøs ujævnt slid"',
    txt_lingt: '0 dæk',
    txt_yt: '1 dæk',
    txt_et: '2 dæk',
    txt_st: '3 dæk',
    txt_ft: '4 dæk',
  
  
  
    //机会
    txt_xsjh: 'Salgs leads',
    txt_gzz: 'Tracking',
    txt_clwb: 'Lukket.',
    txt_ckbg: 'Raport',
    txt_yxs: 'Alle viste data',
    txt_zhuiz: 'Tracking',
    txt_tix: 'Påmind',
    txt_chuli: 'Proecss',
    txt_yzh: 'Konverteret',
    txt_wzh: 'Ikke konverteret',
    txt_gzsmts: ' Dækket har nogle problemer, opsøg din nærmeste mekaniker.',
    txt_czbty: 'Uenig',
    txt_yyx: 'Meningen ',
    txt_ltyg: 'Et dæk',
    txt_ltkg: 'To dæk',
    txt_ltsang: 'Tre dæk',
    txt_ltsig: 'Fire dæk',
    txt_jhcl: 'Peocess',
    txt_jhztai: 'Stat',
    txt_crquy: 'Område',
    txt_chuliry: 'Processer',
    txt_chulijg: 'Lukket.',
    txt_zhuanhuanr: 'Indhold',
    txt_zhuanhuaje: 'Indkomst',
    txt_zhuanhuasj: 'Tid',
    txt_zhuanhuayx: 'Intention',
    txt_xuanzesj: 'Vælg varighed',
    txt_ckxq: 'Detaljer',
    txt_qsrsj: 'Udfyld den anslåede konverteringstid',
  
  
  
    //设备
    txt_sbgl: 'Enhedsadministrator',
    txt_tj: 'Tilføje',
    txt_sbbh: 'Enhedens kode',
    txt_gdssb: '{0} Total antal enheder',
    txt_gjbb: 'Software version',
    txt_tjsj: 'Tidspunkt for tilføjelse',
    txt_zdgx: 'Opdater automatisk',
    txt_gxgj: 'Upgrader enheden',
    txt_jieb: 'Afbryd forbindelsen til enheden',
    txt_sbtsxx: 'Enheden har opdateringer, tryk venligst her for at opdatere',
    txt_wjh: 'Ikke-aktiveret ',
    txt_lix: 'OffLine',
    txt_zaix: 'Online',
    txt_guz: 'Fejl',
    txt_yijieb: 'Enheden er blevet fjernet',
    txt_yihuis: 'Genbrugt',
    txt_gxsbgj: 'Opgrader enhed',
    txt_gxsbgjts: 'Ønsker du at opgradere enheden?',
    txt_socketdk: 'Timeout til serveren, prøv igen',
    txt_cscgts: ' Opdateringsanmodning sendt',
    txt_jbsb: 'Afbryd forbindelsen til enheden',
    txt_jbsbts: 'Ønsker du at afbryde forbindelsen til enheden?',
    txt_tscg: 'Success',
    txt_zdgxgj: 'Opdater automatisk',
    txt_gxgjts: 'Er du sikker på at du vil tænde/slukke den automatiske firmware opdateringsfunktion?',
    txt_beiz: 'Bemærkning',
    txt_qtxbz: 'Indtast venligst dine kommentarer',
    txt_bdsbts: 'Denne app bruges til måling af dæk mønsterdybde med den intelligente detektor, verificer venligst at enhedens oplysninger er korrekte.',
    txt_qdksb: 'Tænd venligst enheden',
    txt_dksbts1: '1.Opkoblingsprocessen starter efter en ny enhed bliver tændt',
    txt_dksbts2: '2. Hvis enheden har været bundet til andre lokationer tidligere, skal du "afkoble" enheden i "indstillinger"-menuen. Efter enheden er afkoblet vil den automatisk starte en ny opkoblings process',
    txt_yjdksblw: 'Enheden har strøm og er forbundet til internettet',
    txt_xyb: 'Næste',
    txt_qsclj: 'Scanne QR-koden',
    txt_qscts1: 'Brug venligst enheden til at scanne QR koden, hvis scanningen lykkedes vil enheden bippe.',
    txt_qscts2: 'Succesfuld scanning',
    txt_sbtssmcg: 'Succesfuld scanning',
    txt_ddsblw: 'Venter på netværk',
    txt_zznlbd: 'Dette kan tage op til ti sekunder, vent venligst.',
    txt_qszdd: 'Dette kan tage op til ti sekunder, vent venligst.',
    txt_bdcg: 'Enhedens binding lykkedes',
    txt_tjcg: 'Tilføjet med success',
    txt_tjcgts: 'Tillykke, enhedener tilføjet. Mærk venligst enheden op for let identificering.',
    txt_fhsblb: 'Tilbage til enhedsliste',
    txt_jxtjsb: 'Tilføj mere',
    txt_bzmc: 'Bemærkelse til enheden',
    txt_bdsb: 'Forbinder.',
  
    //检测记录
    txt_sx: 'Vælg',
    txt_khsj: 'Kundens mobilnummer',
    txt_cphm: 'Nummerplade',
    txt_cphm1: 'Nummerplade',
    txt_clxh: 'Køretøjs model',
    txt_xgbz: 'Ret kommentar',
    txt_gtfjl: 'Antal rapporter',
    txt_jcsj: 'Detektions tid',
    txt_jcsj1: 'Detektions tid',
    txt_xzkssj: 'Start tid',
    txt_xzjssj: 'Slut tid',
    txt_jcjg: 'Resultat',
    txt_msqk: 'Dæk slid',
    txt_jygh: 'Udskift',
    txt_zysh: 'Grænse',
    txt_zcsy: 'Normal',
    txt_zc: 'Normal',
    txt_cz: 'Nulstil',
    txt_qd: 'Bekræft',
    txt_jcjgd: 'Resultat',
    txt_msqkd: 'Dæk slid',
    txt_sldwd: 'Justering',
    txt_jyghd: 'Øjeblikkelig udskiftning anbefales',
    txt_zysh: 'Vær opmærksom',
    txt_zcsyd: 'Normal',
    txt_xdwd: 'Hjuludmåling er nødvendigt',
    txt_xzyd: 'Vær opmærksom',
    txt_zcd: 'Normal',
    txt_bgxq: 'Rapport',
    txt_ljdy: 'Forbinder',
    txt_fwmd: 'Gem',
    txt_mddz: 'Gem adresse',
    txt_jcsb: 'Detektion af udstyr',
    txt_ddmd: 'Formål',
    txt_lic: 'Kilometerstand',
    txt_chex: 'Køretøjs type',
    txt_jcjyi: 'Inspektions anbefalinger',
    txt_ysbs: 'Beskrivelse af farve',
    txt_ztms: 'Generel dækslitage.',
    txt_hwms: 'Ujævn slitage',
    txt_dqscjltx: 'Aktuel påmindelse om bremselængde.',
    txt_bgxqts: ' Påmindelse.',
    txt_wxsmgz: 'Påmindelse',
    txt_hwmsjh: 'Ensartet slid',
    txt_zqlun: 'Inspicer venstre forhjul',
    txt_zhlun: 'Inspicer højre forhjul',
    txt_yqlun: 'Inspicer højre baghjul',
    txt_yhlun: 'Inspicer venstre baghjul',
    txt_pingjunzhi: 'Gennemsnit.',
    txt_guige: 'Størrelse',
    txt_gongli: 'Kilometerstand',
    txt_ltwjc: 'Ikke inspiceret',
    txt_sewmts: 'Scan QR koden for at tjekke rapporten.',
    txt_ltws: 'Dækkenes udseende',
    txt_pinpai: 'Fabrikat',
    txt_print: 'Print',
  
  
    //店员管理
    txt_xz: 'Tilføje',
    txt_qy: 'Aktiver',
    txt_qyz: 'Arbejder',
    txt_ty: 'Deaktiver.',
    txt_yhzh: 'Bruger konto.',
    txt_lxfs: 'Telefonnummer',
    txt_cjsj: 'Tidspunkt for oprettelse',
    txt_bjxx: 'Rediger',
    txt_xgmm: 'Opdater password',
    txt_bgzt: 'Statusændring',
    txt_qdytjm: 'Er du sikker på at du vil deaktivere kontoen?',
    txt_tjdy: 'Tilføj medarbejder',
    txt_bjdyxx: 'Ret medarbejder information',
    txt_zhxx: 'Konto information',
    txt_ygxm: 'Medarbejder navn',
    txt_qtxygxm: 'Indtast venligst medarbejderens navn',
    txt_lxdh: 'Kontakt information',
    txt_qtxyglxdh: 'Telefonnummer',
    txt_dxyzm: 'SMS verifikations kode',
    txt_qtxdxyzm: 'Indtast venligst verifikationskoden',
    txt_fsdx: 'Send SMS',
    txt_tjzh: 'Tilføj konto',
    txt_baocun: 'Gem',
    txt_gtgygzh: 'Total kontoer {0} ',
  
    txt_srczhdmm: 'Angiv din adgangskode',
    txt_kcfs: '{0} s',
  
  
    //登录
    txt_qdytcdlm: 'Klar til at logge ud?',
    txt_qx: 'Afbryd',
    txt_dl: 'Login',
    txt_qsrzh: "Indtast venligst konto ID",
    txt_qsrmm: 'Indtast venligst din adgangskode',
    txt_zcshzh: 'Registrer forhandler',
    txt_shzhwjmm: 'Glemte passowrd',
    txt_yzdqmm: 'Verificer nuværende password',
    txt_szxmm: 'Indstil nyt password',
    txt_xgcg: 'Modificering lykkedes',
    txt_qtxjmm: 'Indtast venligst det gamle password',
    txt_yzzcsj: 'Verificer mobil nummer',
    txt_qtxxmm: 'Indtast venligst det nye password',
    txt_qzctxxmm: 'Gentag det nye password',
    txt_lcmmsrbyz: 'De to passwords stemmer ikke overens',
    txt_gxnxgcg: 'Password er ændret',
    txt_qljndxmm: 'Husk venligst din nye kode',
    txt_fhgrzx: 'Tilbage til hovedmenu',
  
    txt_fsyzm: 'Send sikkerhedskode',
    txt_qtxzcsjh: 'Indtast dit mobilnummer',
    txt_qtxtxyzm: 'Udfyld koden',
    txt_qsryzm: 'Indtast venligst din verifikationskode',
    txt_qszhhmm: 'Lav et password bestående af 6-18 bogstaver- og tal.',
    txt_qzcsrmm: 'Gentag venligst adgangskoden',
    txt_lcmmbyz: 'De to adgangskoder stemmer ikke overens',
    txt_hdsy: 'Tilbage til hovedmenuen',
  
    txt_zcshh: 'Registrer forhandler',
    txt_fhdl: 'Tilbage til login menu',
    txt_wlqqsb: 'Timeout , prøv venligst igen',
    txt_wczc: 'Færdiggør registreringen',
    txt_wsts: 'Udfyld venligst alt information inden du begynder at bruge Appen',
    txt_qtxshmc: 'Udfyld forhandlerens navn',
    txt_shmc: 'Forhandler navn',
    txt_rgszjd: 'Som f.eks. Firma telefonnummer, fax, osv.',
    txt_qtlxfs: 'Andre kontakt informationer',
    txt_kssy: 'Start',
    txt_dphhh: 'Saldo',
    txt_xiugai: 'Modificer',
  
    txt_zzjzsj: 'Indlæser',
    txt_bjshxx: 'Tilpas forhandler',
    txt_chongxinhq: 'Gensend',
    txt_gaibangsj: 'Ret mobilnummer ',
    txt_yanzhengjsj: 'Verificer gammelt mobilnummer',
    txt_bangdingxsj: 'Forbind til ny mobil telefon',
    txt_yhqsyxsjdl: 'Log venligst ind med en ny mobil telefon',
  
  
    //门店
    txt_mendianId: 'Forretnings ID',
    txt_mendianmc: 'Gem navn',
    txt_mendiandz: 'Gem adresse',
    txt_mendiandh: 'Gem telefonnummer. ',
    txt_caozuo: 'Operer',
    txt_mendiangl: 'Butikker',
    txt_gjmendian: 'Total  {0} butikker',
    txt_zhengchangyy: 'Åben',
    txt_tingye: 'Lukket.',
    txt_gengdxx: 'Mere',
    txt_dianygl: 'Medarbejdere',
    txt_biangzt: 'Skift status',
    txt_qdygbzhuangtai: 'Vær sikker på at du har inaktiveret  {0} forretningen.',
    txt_bjmendian: 'Rediger',
    txt_xinzenmd: 'Tilføj ny butik',
    txt_qtxmdmc: 'Udfyld venligst butiksnavnet',
    txt_qxzmddz: ' Vælg venligst butikkens adresse',
    txt_qtxxdz: 'Udfyld venligst butikkens adresse',
    txt_xiangxidz: 'Detaljeret adresse',
    txt_qtxmddh: 'Udfyld venligst butikkens telefonnummer',
    txt_dzxx: 'Manager information',
    txt_chaungjianmendian: 'Opret butik',
    txt_mendianxxxx: 'Detaljeret information',
    txt_bianji: 'Redigere',
    txt_mendianzt: 'Butiks status',
  
    //商户数据总览
    txt_mendianshuju: 'Butiks data',
    txt_chakangdxxbb: 'Tjek flere rapporter',
    txt_jczcs: 'Total inspektion',
    txt_mdpjjc: 'Standard inspektion',
    txt_jdzcl: 'Samlet gennemgang af køretøjer',
    txt_jcl: 'Inspektionsrate',
    txt_msqkjgtj: '磨损情况结果统计（轮胎条数）',
    txt_xyghltjgfb: '需更换轮胎的结果分布',
    txt_xzzyltjgfb: '需注意轮胎的结果分布',
    txt_sldwjgtj: '四轮定位结果统计（轮胎条数）',
    txt_xjxsldwfb: '需进行四轮定位轮胎的结果分布',
    txt_xzzyjxsldwfb: '需注意准备进行四轮定位轮胎的结果分布',
    txt_jrzl: 'Overblik',
    txt_xiangqbb: 'Detaljer',
    txt_xuanzerqckxxsj: 'Vælg dato',
    txt_qxzsjd: 'Vælg periode',
    txt_sjdts: 'Du kan kun vælge en periode indenfor de seneste 30 dage',
    txt_zonglan: 'Overblik',
    txt_qushi: 'Trend',
    txt_shuliangtj: 'Statistik over antal',
    txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
    txt_mslttsfb: '磨损轮胎条数分布情况',
    txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
    txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
    txt_sldwfbqk: '四轮定位结论条数分布情况',
    txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
    txt_jccsqs: "Inspektionstrend, antal",
    txt_msqkslqs: 'Trend af dækslid',
    txt_jgfbqushi: '磨损轮胎需更换轮胎的结果分布趋势',
    txt_msltjgfbqs: '磨损轮胎需注意轮胎的结果分布趋势',
    txt_ltxsldwslqs: '轮胎需四轮定位情况数量趋势',
    txt_jccs: "Total antal inspektioner",
    txt_shuliang: 'Antal',
    txt_zhanbi: '%',
    txt_chankangd: 'Mere',
    txt_chakanmdxxbb: 'Detaljer',
  
  
  
    //登录新
    txt_xzshenfen: 'Vælg venligst din nye rolle',
    txt_dlrolewz: 'Login {0} bruger ',
    txt_qsrsjh: 'Indtast venligst telefonnummeret',
    txt_zhuce: 'Registrering',
    txt_wanjimima: 'Glem password',
    txt_wanshandzxx: 'Udfyld venligst alt informationen',
    txt_qsrxm: ' Indtast dit navn',
    txt_qsrmdm: 'Indtast forretningens navn',
    txt_qsrmdgddh: 'Indtast telefonnummeret',
    txt_qsrmddz: 'Indtast adressen på forretningen',
    txt_qsrgsdz: 'Indtast venligst forretningens adresse',
    txt_qsrxxdz: 'Indtast venligst en detaljeret adresse',
    txt_tijiaocg: 'Indsendt med success',
    txt_qsvbsylwmm: 'Password skal være minimum 6 tegn',
    txt_zhucerole: 'Registrer',
    txt_qsrshh: 'Tilgå venligst forhandler kontoen',
    txt_qsrdzh: 'Tilgå venligst manager kontoen',
    txt_wsshhzl: 'Udfyld venligst forhandler informationen',
    txt_wsdyhzl: 'Udfyld venligst medarbejder informationen',
    txt_qsrshm: 'Udfyld venligst forhandlerens navn (firma navn) ',
    txt_qsrshz: 'Indtast venligst forretningens ejer',
    txt_qsrzrqy: 'Udfyld venligst arbejdsområdet',
    txt_shanghudizhi: 'Forhandler adresse',
    txt_yhycz: 'Brugeren findes allerede',
    txt_qsrzqdzh: ' Udfyld venligst den korrekte manager konto ',
    txt_qsrzqshh: ' Udfyld venligst den korrekte forhandler konto',
    txt_xzmdcx: 'Vælg forretningen du ønsker at benytte',
  
    //国家
    txt_zhongguo: 'Kina',
    txt_mlxy: 'Malaysia',
    txt_yindu: 'Indien',
    txt_taiguo: 'Thailand',
    txt_oluosi: 'Rusland',
  
  
  
    txt_taici: 'Køretøjer',
    txt_jianyi: 'Forslag',
    txt_jianyineirong: 'Dækket har ujævnt slid, yderligere gennemgang anbefales',
    txt_jianyineirongzc: 'Normal',
    txt_bgtixing: 'Påmindelse:',
    txt_bgtuxubfnr: 'Ifølge dækkets slid, er bremselængden øget med  {0}% (estimeret)',
    txt_scsltjcy: 'Håndholdt slitage tester',
    txt_xichemeirong: 'Bilvask & klargøring',
    txt_weixiubaoyang: 'Vedligeholdelse',
    txt_guenghuanluntai: 'Udskiftning af dæk',
    txt_waishang: 'Dæk beskadiget',
    txt_laohua: 'Gamle',
    txt_gubao: 'Udbulning',
    txt_shijiantishi: 'Start tidspunktet skal være før slut tidspunktet',
  
    txt_qxzclry: 'Vælg venligst processoren',
  
  
    txt_lf_outworn: 'Venstre fordæk er mere slidt udvendig, end der er indvendigt.',
    txt_lf_innerworn: 'Venstre fordæk er mere slidt indvendigt, end det er udvendigt.',
    txt_lf_bothsideworn: 'Venstre fordæk har større slitage på begge ydersider, end på midten.',
    txt_lf_centreworn: 'Venstre fordæk har større slitage på midten, end det har på ydersiderne.',
    txt_lb_outworn: 'Venstre bagdæk har større slitage på ydersiden, end det har på indersiden.',       
    txt_lb_innerworn: 'Venstre bagdæk har større slitage på indersiden, end det har på ydersiden.',        
    txt_lb_bothsideworn: 'Venstre bagdæk er mere slidt på ydersiderne, end på midten.',        
    txt_lb_centreworn: 'Venstre bagdæk er mere slidt på midten, end det er på ydersiderne.',        
    txt_rb_outworn: 'Højre bagdæk er mere slidt på ydersiderne, end det er på midten.',         
    txt_rb_innerworn: 'Højre bagdæk er mere slidt på på midten, end der er på ydersiderne.',        
    txt_rb_bothsideworn: 'Højre bagdæk er mere slidt på ydersiderne, end det er på midten.',         
    txt_rb_centreworn: 'Højre bagdæk er mere slidt på midten, end det er på ydersiderne.',        
    txt_rf_outworn: 'Højre fordæk er mere slidt på ydersiden, end det er på indersiden.',         
    txt_rf_innerworn: 'Højre fordæk er mere slidt på indersiden, end det er på ydersiden.',        
    txt_rf_bothsideworn: 'Højre fordæk er mere slidt på begge sider, end det er på midten.',       
    txt_rf_centreworn: 'Højre fordæk er mere slidt på begge sider, end det er på midten.',  
    txt_tire_need_replace: 'Dækslitage status, bør udskiftes straks !',


    txt_tire_boundary: 'Dækslitage status: lige på grænsen til at det burde blive udskiftes.',
    'txt_tire_boundary;': 'Dækslitage status: lige på grænsen til at det burde blive udskiftes.',
    txt_alignment_chassis: 'Undervogns komponenter bør tjekkes, efterfulgt af en 4 hjulsudmåling.',
    txt_wear_uniform: 'Dækslitage er ensartet, og OK.',
    'txt_wear_uniform;': 'Dækslitage er ensartet, og OK.',
    txt_do_further_check: 'Kontroller venligst yderligere.',
    txt_uneven_check: 'Dækslid er unormalt, anbefales det at flytte balancen og firehjulspositionering, inspektion af affjedringssystem.',
    'txt_uneven_check;': 'Dækslid er unormalt, anbefales det at flytte balancen og firehjulspositionering, inspektion af affjedringssystem.',
    txt_tire_rotation: 'Det anbefales at rotere rundt på dækkene.',
    txt_wear_normal: 'Dækslitage mønster er normalt',
    'txt_wear_normal;': 'Dækslitage mønster er normalt',
    txt_tire: 'Dæk',
    txt_xiazai: 'Download',
    txt_xiazaishibai: 'Download fejlede',
  
  
    //报告页新增
    'txt_tire_age_8': 'Der er dæk har været brugt i mere end 8 år, anbefales det at foretage en omfattende inspektion af dæk',
    'txt_tire_age_6': 'Der er dæk, der har været brugt i mere end 6 år',
    'txt_tire_age_5': 'Dækket er mere end 5 år, og det anbefales at udskifte det',
    'txt_tire_age_3': 'Dækkene er mere end 3 år gamle, det anbefales at holde godt øje med dem',
    'txt_tire_age_ok': 'Dækkets DOT er OK',
    'txt_tire_age_ok;': 'Dækkets DOT er OK',
    'txt_tire_trauma_check': 'Dækket er beskadiget, tjek venligst yderligere.',
    'txt_install_abnormal_check': 'Dækmonteringen er ukorrekt, bekræft venligst.',
    'txt_tire_appearance_ok': 'Dækket ser fint ud, alt OK',
    'trauma_lacerate': 'lacorate',
    'trauma_dropblock': 'Drop block',
    'trauma_puncture': 'Punktering',
    'trauma_scratch': 'Ridse',
    'txt_tire_age': 'Dækkets DOT',
    'txt_tire_appearance': 'Dækkenes udseende',
    //未翻译
    txt_plcl: 'Parti',
    txt_qbxz: 'Vælg alle',
    txt_scjcjg: 'Sidste inspektions resultat',
    txt_ltxhlcgs: 'Estimat på resterende levetid',
    txt_ltazhuang: 'Dæk installation:',
    txt_wear_overall: 'Generel dækslitage.',
    txt_pattern_wear: 'Ujævn',
    txt_ltlcgstm: 'Ifølge den nuværende dækslid situation, dæk kilometertal er {0} km (anslået værdi)',
    txt_yichang: 'Dæk unormalt',
    txt_qjybjcltazqk: 'Tjek dækinstallationen yderligere',
    txt_dottx: 'Dæk holdbarhed estimat',
    txt_dottxjy: 'Dæk har været brugt i mere end 3 år, tjek dem regelmæssigt',
    txt_danweinian: 'Enhed: år',
    txt_danweikm: 'Enhed: kilometer',
    txt_shurujb: "Enter '100' to disarm the device",
    txt_shuruzqwa: 'Skriv tekst som bedt om det',
    txt_myhqdsj: 'Ingen DOT',
    txt_dotjstx: 'Den resterende levetid for dækket er omkring {0} dage',
    txt_dotjstx2: 'Levetiden for dæk har overskredet 5 år,  du bør udskifte dem straks',
    txt_dotsjztx: '(dæk fremstillingsdato)',
    txt_gelie: 'lacorate',
    txt_diaokuai: 'Drop block',
    txt_chaungci: 'Punktering',
    txt_cashang: 'Skramme',
    txt_yichang: 'Dæk unormalt',
    'txt_tire_need_replace;': 'Dækslitage status, bør udskiftes straks !',
  
    //未翻译
    txt_jishimz: 'Tekniker',
    txt_ltlcgsnew: 'Dækkets resterende rækkevidde er',
    txt_ltlcgsnewin: 'Dæk rækkevidde er {0} miles',
    txt_msjxtx:'Dækket har nået sin begrænsning, skift venligst dækket',
    txt_ltfz:'Dæk er monteret omvendt',
    txt_pinnate_check: 'Der er pinnate slid på dækket. Det anbefales at tjekke det yderligere.',
    txt_pinnate_wear: 'Pinnate slid',
   
    txt_install_check: 'Installationskontrol',
    txt_install_ok:'Installation er OK',
    LF:'[Venstre fordæk]',
    RF:'[Højre fordæk]',
    LB:'[Venstre bagdæk]',
    RB:'[Højre bagdæk]',
    FF:'Forreste akse',
    BB:'Bag akse',
    txt_appearance_check:'Dækket er beskadiget, tjek venligst dækket',
    txt_uneven_center:'Unormalt slitage i midten af dækket, tjek venligst dæktrykket',
    txt_uneven_out:'Ydersiderne af dækket har ujævnt slid, tjek venligst dæktrykket.',
    txt_pinnate_check:'Der er pinnate slid på dækket. Det anbefales at tjekke det yderligere.',
    txt_uneven_inside :'Indersiden af dækket har unormal slid. Tjek venligst dæktrykket og om hjulene er indstillet korrekt. (hjuludmåling)',
    txt_uneven_bothside:'Begge sider af dækket har ujævn slitage, tjek venligst lufttryk og om hjulene er indstillet korrekt (hjuludmåling)',
    
    txt_msyzljgh:'Dækket er slidt, det anbefales at det bliver skiftet',
    txt_serious_trauma_check:"Dækket er svært beskadiget, en udskiftning anbefales",
    txt_appearance_lookup:"Tjek venligst udseendet på dækket",
    txt_wear_lookup :"Tjek venligst dækket for slitage",
    txt_dotscsj:'Produktionsdato: {0} ({1} år {2} uge),',
    txt_whqdscsj:'Produktionsdato kunne ikke indlæses',
    purp_tireservice:'Dæk service',
    purp_vehicle_inspection:'Inspektion af køretøj', 
    txt_chassis_check :'Kontrol af chassis',
    txt_chassis_ok:'Chassis er OK',
    txt_chassis_oil:'Støddæmperne lækker olie, tjek venligst yderligere',
    txt_chassis_aging :'Akselhovedts gummi er gammelt, udskiftning anbefales.',
  
    //cormach
    txt_hood:'Motorhjelm',
    txt_wash_liquid:'Vinduesvisker væske',
    txt_level_control:'Niveau kontrol',
    txt_haoxiaoxi:'OK',
    txt_vedi_Note:'Manuel tjek',
    txt_replace1:'Erstatning',
    txt_radiator_fluid:'Kølemiddel',
    txt_engine_oil:'Motorolie',
    txt_brake_fluid:'Bremsevæske',
    txt_quality_control:'Kvalitetskontrol',
    txt_multimeter:'Multimeter',
    txt_subtotal:'Mængde',
    txt_shock_absorber:'Støddæmpere',
    txt_check_loss:'Tjek tabt',
    txt_brake_disc:'Bremseskive',
    txt_wear_condition:'Status på slitage',
    txt_brake_pads:'Bremseklodser',
    txt_change_control:'Andre kontrolsystemer',
    txt_air_control:'Klimaanlæg',
    txt_last_reload:'Indlæser sidste gang',
    txt_lighting:'Lys',
    txt_verification1:'Vnduesviskere',
    txt_dynamometer:'Dynamometer',
    txt_batteria:'Batteri',
    txt_verification:'Verificerer..',
    txt_levellow:'Ok',
    txt_levelmiddle:'Manuelt tjek',
    txt_levelhigh:'Erstatning',
    txt_tyrenumber:'Scanner dybde:',
    txt_cormach_title:'Slitage og ujævn slitage',
    txt_wearlow:'Ensartet slid',
    txt_wearmiddle:'En smule uens',
    txt_wearhigh:'Meget uens',
    txt_namtishi:'1/32 del',
    txt_zhiliangkongzhi:'Kvalitetskontrol',
    txt_buchongzhengduan:'Diagnose',  
    txt_season_summer:'Sommer Dæk',
    txt_season_winter:'Winnter Dæk',
  
    //米其林新加
    txt_trauma_eattyre:'Meget uens slitage',
    txt_uneven_eattyre:'Dækket har meget uens slid, tjek venligst affjedringen',
    txt_appearance_eattyre:'Dækket har meget uens slid, tjek venligst affjedringen',
    txt_chassis_eattyre:'Dækket har meget uens slid, tjek venligst affjedringen',
    txt_uneven_high_eattyre:'Dækket har meget uens slid, tjek venligst affjedringen',
    txt_appearance_high_eattyre:'Dækket har meget uens slid, tjek venligst affjedringen',
    txt_chassis_high_eattyre:'Dækket har meget uens slid, tjek venligst affjedringen',
    txt_chassis_uneven:'Dækket har meget uens slid, tjek venligst affjedringen',
    txt_pianmoyichang:'Unormal slitage mønster',
    txt_qiao: 'Akse',
    txt_left: 'Venstre',
    txt_right: 'Højre',
    txt_lun: 'Dæk',
    txt_huawen: 'Dækmønster',
    txt_taihao: 'Dæk nummer',
    txt_taiya: 'Dæktryk',
    txt_chexlw: 'Hjul position',
    txt_jiancerenyuan: 'Tekniker',
    txt_beitai:'Reservehjul',
    txt_tuoche:'Traktor',
    txt_guache:'Anhænger/trailer',
  
  
  
  
    txt_khxm:'Kundens navn',
    txt_khyx:'Kundens email',
  
  
  }


// WEBPACK FOOTER //
// ./src/i18n/danish.js